import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import type { ISuggestedProductModal } from '../types';

type SuggestedProductModalProviderProps = {
  children: ReactNode;
};

type SuggestedProductModalContextValue = {
  isSuggestedProductModalOpen: boolean;
  setIsSuggestedProductModalOpen: (open: boolean) => void;
  suggestedProductModalData?: ISuggestedProductModal;
  setSuggestedProductModalData: (
    data: ISuggestedProductModal | undefined,
  ) => void;
};

const SuggestedProductModalContext =
  createContext<SuggestedProductModalContextValue>({
    isSuggestedProductModalOpen: false,
    setIsSuggestedProductModalOpen: () => null,
    suggestedProductModalData: undefined,
    setSuggestedProductModalData: () => null,
  });

const SuggestedProductModalProvider = ({
  children,
}: SuggestedProductModalProviderProps) => {
  const [isSuggestedProductModalOpen, setIsSuggestedProductModalOpen] =
    useState<boolean>(false);
  const [suggestedProductModalData, setSuggestedProductModalData] = useState<
    ISuggestedProductModal | undefined
  >(undefined);

  const value = useMemo(
    () => ({
      isSuggestedProductModalOpen,
      setIsSuggestedProductModalOpen,
      suggestedProductModalData,
      setSuggestedProductModalData,
    }),
    [isSuggestedProductModalOpen, suggestedProductModalData],
  );

  return (
    <SuggestedProductModalContext.Provider value={value}>
      {children}
    </SuggestedProductModalContext.Provider>
  );
};

const useSuggestedProductModal = () => useContext(SuggestedProductModalContext);

export { SuggestedProductModalProvider, useSuggestedProductModal };
